import noop from 'hs-lodash/noop';
import { getNotificationSoundsWithIds, playNotificationSound } from 'notification-sounds';
import Raven from 'raven-js';
import { useGlobalNotificationSound } from './hooks';

/**
 * Return a function that accepts a nullable notification sound preference. When called the
 * requested notification sound will be played if valid, otherwise the global fallback will
 * be used. a sound id of 0 means OFF and no sound will be played nor the fallback used.
 */
const useGetPlaySound = () => {
  const {
    globalNotificationSoundDuration,
    playGlobalNotificationSound
  } = useGlobalNotificationSound();
  const getPlaySound = notificationSound => {
    if (notificationSound) {
      if (notificationSound.soundId === 0) {
        return [noop, 0];
      }
      const preferredSound = getNotificationSoundsWithIds().find(({
        id
      }) => id === notificationSound.soundId);
      if (preferredSound) {
        const playPreferredSound = () => playNotificationSound(preferredSound.name).catch(e => Raven.captureException(e));
        return [playPreferredSound, preferredSound.duration * 1000];
      }
    }
    return [playGlobalNotificationSound, globalNotificationSoundDuration];
  };
  return getPlaySound;
};
export default useGetPlaySound;